import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import RegisterModal from "./components/RegisterModal";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ProgramsPage from "./pages/ProgramsPage"; // ✅ RESTORED
import InternshipPage from "./pages/InternshipPage";
import ContactPage from "./pages/ContactPage";
import ProgramDetailPage from "./pages/ProgramDetailPage";

// 📍 GEOGRAPHIC LOCAL SEO LANDING (Explicit Extension)
import IndoreHubPage from "./pages/IndoreHubPage.jsx"; 

// 🔥 PRIORITY TRACK COUPLING FOR LOCAL DOMINANCE (Explicit Extension)
import CybersecurityTrainingIndore from "./pages/cybersecurity-training-indore.jsx";

function App() {
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);

  const handleRegisterTrigger = () => setIsRegisterModalOpen(true);
  const handleRegisterClose = () => setIsRegisterModalOpen(false);

  return (
    <BrowserRouter>
      <div className="App">
        {/* Navigation Layer Passing State Animation Triggers */}
        <Header onRegister={handleRegisterTrigger} />
        
        <Routes>
          {/* Main Website Landings */}
          <Route path="/" element={<HomePage onRegister={handleRegisterTrigger} />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/internship" element={<InternshipPage />} />
          <Route path="/contact" element={<ContactPage />} />
          
          {/* 📍 GEOGRAPHIC LOCAL SEO LANDING */}
          <Route path="/indore" element={<IndoreHubPage />} />

          {/* 📚 RESTORED GENERAL OVERVIEW COLLECTION */}
          <Route 
            path="/programs" 
            element={<ProgramsPage />} 
          />

          {/* 🎯 DEDICATED EXCLUSIVE ROUTE FOR CYBERSECURITY ENGINE */}
          <Route 
            path="/cybersecurity-training-indore" 
            element={<CybersecurityTrainingIndore onRegister={handleRegisterTrigger} />} 
          />

          {/* Dynamic Catch-All Pipeline for Remaining Tech Modules (AIML, Python, GRC, MERN) */}
          <Route 
            path="/programs/:slug" 
            element={<ProgramDetailPage onRegister={handleRegisterTrigger} />} 
          />
        </Routes>

        <Footer />
        
        {/* Global Structural Modal Overlays */}
        <RegisterModal 
          isOpen={isRegisterModalOpen}
          onClose={handleRegisterClose}
        />
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;